import { render } from "./RegistroLecheCaliente.vue?vue&type=template&id=7f55ce96"
import script from "./RegistroLecheCaliente.vue?vue&type=script&lang=js"
export * from "./RegistroLecheCaliente.vue?vue&type=script&lang=js"

import "./RegistroLecheCaliente.vue?vue&type=style&index=0&id=7f55ce96&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__